import { defineStore } from "pinia";
import { ref, watch } from 'vue'
import { useStore as useVuexStore } from 'vuex';
import { storeToRefs } from "pinia";


import { carregarParecerMinimo, carregarDisciplinasDaArea, carregarObjetivosArea, salvarParecerMinimoFetch, atualizarParecerMinimoFetch, salvarObjetivosArea, carregarCompetenciasPorTrimestre, salvarCompetenciaFetch, atualizarCompetenciaFetch, excluirCompetenciaFetch, atualizarSugestaoFetch, excluirSugestaoFetch, salvarSugestaoFetch, carregarSugestoesFetch } from "@/api/fetchParecer";

import { carregarCriteriosRubrica } from '@/store/criteriosRubricaFetch';


import { calcularParecerObjetivoArea, calcularParecerSugestoes, calcularParecerDificuldadesDestaques } from "@/utils/calcularParecer";


export const useCriarParecerStore = defineStore('criarParecer', () => {
    // Dados Base
    const user = ref(null);
    const vuexStore = useVuexStore();
    user.value = vuexStore.state.userSession.user;
    console.log("Usuário")
    console.log(user.value);
    const anoSelecionado = ref("1");
    const trimestreSelecionado = ref("1");
    const disciplinasDaArea = ref([]);
    const criteriosDaRubrica = ref([]);
    const idDaTurma = ref(null);
    const idDaArea = ref(null);


    const desempenhoPorComponente = ref([
        { disciplina: 1, notacao: 2 },
        { disciplina: 2, notacao: 4 },
        { disciplina: 3, notacao: 3 },
        { disciplina: 4, notacao: 4 },
    ])

    // Conteúdos do parecer
    const parecerMinimo = ref({});
    const objetivosArea = ref({ conteudo: [] });
    const competencias = ref([]);
    const sugestoesMelhoria = ref([])

    // Controles de desempenho
    const controleDesempenhoPorCriterio = ref([
        { id: 1, criterio: "Construção do conhecimento", desempenho: 30 },
        { id: 2, criterio: "Resolução de problemas", desempenho: 80 },
        { id: 3, criterio: "Comunicação", desempenho: 90 },
        { id: 5, criterio: "Trabalho em grupo", desempenho: 50 },
        { id: 6, criterio: "Autorregulação", desempenho: 80 }
    ]);

    const desempenhoPorCompetencia = ref([

    ])

    // Partes do Parecer
    const parecerParte1 = ref('');
    const parecerParte2 = ref('');
    const parecerParte3 = ref('');

    // Monitorar mudanças nos dados
    watch([desempenhoPorComponente, desempenhoPorCompetencia,controleDesempenhoPorCriterio], () => {
        
        calcularParecer();
    }, { deep: true });

    watch(competencias, () => {
        desempenhoPorCompetencia.value = [];
        competencias.value.forEach(item => {
            desempenhoPorCompetencia.value.push({ ...item, desempenho: 95 })
        })
        calcularParecer();
    }, { deep: true });

    watch(parecerMinimo, () => {
        if (parecerMinimo.value.texto !== "") {
            parecerMinimo.value.status = parecerMinimo.value.status === "novo" ? "novo" : 'modificado';
            salvarParecerMinimo();
            calcularParecer();
        }
    }, { deep: true });


    watch(objetivosArea, () => {
        salvarECarregarObjetivosArea()
        calcularParecer();

    }, { deep: true })


    // Manipulação de dados
    async function salvarParecerMinimo() {
        if (parecerMinimo.value.status == 'novo') {
            let idParecer = await salvarParecerMinimoFetch(parecerMinimo.value);
            parecerMinimo.value.status = 'salvo';
            parecerMinimo.value.id = idParecer;
        } else if (parecerMinimo.value.status === 'salvo' || 'modificado') {
            atualizarParecerMinimoFetch(parecerMinimo.value)
        }
    }
    async function salvarECarregarObjetivosArea() {
        let novosObjetivosSalvos = await salvarObjetivosArea(objetivosArea.value);
        if (novosObjetivosSalvos === 'novosObjetivosSalvos') {
            objetivosArea.value.conteudo = await carregarObjetivosArea(trimestreSelecionado.value, anoSelecionado.value, disciplinasDaArea.value);
        }
    }

    async function carregarDados() {
        
        parecerMinimo.value = await carregarParecerMinimo(trimestreSelecionado.value, anoSelecionado.value, user.value.areaId);

        criteriosDaRubrica.value = await carregarCriteriosRubrica();

        disciplinasDaArea.value = await carregarDisciplinasDaArea(user.value.areaId);
        console.log(disciplinasDaArea.value)

        objetivosArea.value.conteudo = await carregarObjetivosArea(trimestreSelecionado.value, anoSelecionado.value, disciplinasDaArea.value);

        competencias.value = await carregarCompetenciasPorTrimestre(disciplinasDaArea.value, trimestreSelecionado.value, anoSelecionado.value);
        
        desempenhoPorCompetencia.value = [];
        competencias.value.forEach(item => {
            desempenhoPorCompetencia.value.push({ ...item, desempenho: 70 })
        })

        console.log(desempenhoPorCompetencia.value)

        sugestoesMelhoria.value = await carregarSugestoesFetch(user.value.areaId, trimestreSelecionado.value, anoSelecionado.value)

        calcularParecer();
    }

    async function carregarDadosParaDefinirParecerParaEstudantes(){

    }

    function calcularParecer() {
        if(objetivosArea.value.conteudo.length > 0){
            parecerParte1.value = calcularParecerObjetivoArea(parecerMinimo.value, objetivosArea.value.conteudo, desempenhoPorComponente.value);
        }else{
            parecerParte1.value = "";
        }
        
        parecerParte2.value = calcularParecerDificuldadesDestaques(desempenhoPorCompetencia.value, desempenhoPorComponente.value, disciplinasDaArea.value);
        if(sugestoesMelhoria.value.length > 0){
            parecerParte3.value = calcularParecerSugestoes(controleDesempenhoPorCriterio.value, sugestoesMelhoria.value, user.value.areaNome, desempenhoPorComponente.value);
        }else{
            parecerParte3.value = '';
        }
        
    }

    function adicionarCampoCompetencia() {
        competencias.value.push({
            id: null,
            competencia: '',
            trimestre: trimestreSelecionado.value,
            ano: anoSelecionado.value,
            disciplina: user.value.disciplina,
            status: 'novo'
        })
    }

    async function salvarCompetencia(index) {
        if (index >= 0 && index < competencias.value.length) {
            const item = competencias.value[index];
            if (item.status == "novo") {
                let competenciaSalva = await salvarCompetenciaFetch(item);
                item.id = competenciaSalva;
                item.status = "salvo";
            } else {
                atualizarCompetenciaFetch(item);
            }
        }
    }

    function excluirCompetencia(index) {
        if (index >= 0 && index < competencias.value.length) {
            const item = competencias.value[index];
            if (item.status !== "novo") {
                excluirCompetenciaFetch(item.id)
                competencias.value.splice(index, 1);
            } else {
                competencias.value.splice(index, 1);
            }
        }
    }

    function adicionarCampoSugestaoMelhoria() {
        sugestoesMelhoria.value.push({
            id: null,
            sugestao: '',
            trimestre: trimestreSelecionado.value,
            ano: anoSelecionado.value,
            area: user.value.areaId,
            criterio: 1,
            status: 'novo'
        })
    }

    async function salvarSugestaoMelhoria(index) {
        if (index >= 0 && index < sugestoesMelhoria.value.length) {
            const item = sugestoesMelhoria.value[index];
            if (item.status == "novo") {
                let sugestaoId = await salvarSugestaoFetch(item);
                item.id = sugestaoId;
                item.status = "salvo";
            } else {
                atualizarSugestaoFetch(item);
            }
        }

        calcularParecer()
    }

    function excluirSugestaoMelhoria(index) {
        if (index >= 0 && index < sugestoesMelhoria.value.length) {
            const item = sugestoesMelhoria.value[index];
            if (item.status !== "novo") {
                excluirSugestaoFetch(item.id)
                sugestoesMelhoria.value.splice(index, 1);
            } else {

                sugestoesMelhoria.value.splice(index, 1);
            }
        }
    }

    // dados específicos para definir parecer para os estudantes

    return { anoSelecionado, trimestreSelecionado, idDaTurma, idDaArea, disciplinasDaArea, criteriosDaRubrica, objetivosArea, desempenhoPorComponente, parecerMinimo, competencias, sugestoesMelhoria, controleDesempenhoPorCriterio, desempenhoPorCompetencia, parecerParte1, parecerParte2, parecerParte3, carregarDados, adicionarCampoCompetencia, salvarCompetencia, excluirCompetencia, salvarSugestaoMelhoria, excluirSugestaoMelhoria, adicionarCampoSugestaoMelhoria }
})